module.exports = {
  title: 'Family Alert Drawer with Reanimated',
  author: 'Enzo Manuel Mangano',
  date: '2024-09-17',
  slug: 'alert-drawer',
  tags: ['reanimated'],
};
